export default "__VITE_ASSET__CN_okZyU__"